import { Navigate, RouteObject } from 'react-router-dom'
import { lazy, Suspense } from 'react'

const Discover = lazy(() => import('@/pages/discover'))
const Mine = lazy(() => import('@/pages/mine'))
const Friend = lazy(() => import('@/pages/friend'))
const Recommend = lazy(() => import('@/pages/discover/cpms/recommend'))
const Ranking = lazy(() => import('@/pages/discover/cpms/ranking'))
const Songs = lazy(() => import('@/pages/discover/cpms/songs'))
const Djradio = lazy(() => import('@/pages/discover/cpms/djradio'))
const Artist = lazy(() => import('@/pages/discover/cpms/artist'))
const Album = lazy(() => import('@/pages/discover/cpms/album'))
const Player = lazy(() => import('@/pages/player'))

/** 懒加载 */
const LoadingComp = (comp: React.ReactElement) => <Suspense fallback={<div>page loading</div>}>{comp}</Suspense>

/** 和 v5 配置差别较大 */
const routes: RouteObject[] = [
    { path: '/', element: <Navigate to="/discover" /> },
    {
        path: '/discover',
        element: LoadingComp(<Discover />),
        children: [
            {
                path: '/discover',
                element: <Navigate to="/discover/recommend" />,
            },
            {
                path: '/discover/recommend',
                element: LoadingComp(<Recommend />),
            },
            {
                path: '/discover/ranking',
                element: LoadingComp(<Ranking />),
            },
            {
                path: '/discover/songs',
                element: LoadingComp(<Songs />),
            },
            {
                path: '/discover/djradio',
                element: LoadingComp(<Djradio />),
            },
            {
                path: '/discover/artist',
                element: LoadingComp(<Artist />),
            },
            {
                path: '/discover/album',
                element: LoadingComp(<Album />),
            },
            {
                path: '/discover/player',
                element: LoadingComp(<Player />),
            },
        ],
    },
    {
        path: '/mine',
        element: LoadingComp(<Mine />),
    },
    {
        path: '/friend',
        element: LoadingComp(<Friend />),
    },
]

export default routes
